<div class="contentContainer">
  <p>{{'alert.Access_group_premium' | translate}} </p>
  <p> <a [routerLink]="['/premium']" (click)="activeModal.close()"> {{'alert.Subscribe' | translate}} </a> {{'alert.To_access' | translate}}.</p>
</div>
